<template>
  <div>
    <div class="padding">
      <van-checkbox-group v-model="model.characteristic">
        <van-checkbox v-for="(option,index) in options" :name="option" :key="index" shape="square" style="margin: 20px 0 ">{{option}}</van-checkbox>
      </van-checkbox-group>
      <div class="text-center margin-tb" style="margin-top: 50px">
        <van-button type="primary" size="large" @click="submit">保存</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Cell, CellGroup, Checkbox, CheckboxGroup, Button, Toast, Dialog, Field, Icon, ActionSheet} from 'vant';
import {
  updateCharacteristic, getCharacteristic
} from '@/api/clerk/clerk'

Vue.use(Cell)
    .use(CellGroup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(ActionSheet)

export default {
  name: 'updateCharacteristic',
  data() {
    return {
      options: [],
      model:{
        characteristic: [],
      }
    }
  },
  methods: {
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getCharacteristic().then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          this.options = data.data.options
          this.model.characteristic = data.data.characteristic || []
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    submit() {
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })

      updateCharacteristic(JSON.stringify(this.model.characteristic)).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '提交成功'
          }).then(() => {
            this.$router.back(-1)
          })
        } else {
          this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    },
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="less" scoped>


</style>
